export default __webpack_public_path__ + "static/media/section-about-img-6.f39f27dd.png";